(function () {
  function initHowto(howto) {
    var steps = howto.querySelectorAll('.jf-howto__step');
    var images = howto.querySelectorAll('.jf-howto__image');
    if (!steps.length) return;

    var active = 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // The step images this timer rotates are hidden entirely on mobile
    // (see _howto-group.liquid's @media max-width:749px rule) since there's
    // no room for the side-by-side image next to the step list there. With
    // nothing visible to rotate to, the timer was left just auto-expanding/
    // collapsing a different accordion step every 4s with no user input —
    // read as random "flashing" rather than a feature. Desktop keeps the
    // auto-advance since the image swap it drives is still visible there.
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    function setActive(index) {
      active = index;
      steps.forEach(function (step, i) {
        step.classList.toggle('jf-howto__step--active', i === index);
      });
      images.forEach(function (img, i) {
        img.classList.toggle('jf-howto__image--active', i === index);
      });
    }

    function startTimer() {
      if (reduceMotion || isMobile || steps.length < 2) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        setActive((active + 1) % steps.length);
      }, 4000);
    }

    steps.forEach(function (step, i) {
      step.addEventListener('click', function () {
        setActive(i);
        startTimer();
      });
    });

    setActive(0);
    startTimer();
  }

  document.querySelectorAll('.jf-howto').forEach(initHowto);
})();
